import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { gsap } from "gsap";
import { Subscription } from 'rxjs';
import { LotteryService } from 'src/app/services';
import { ClientService } from 'src/app/services/client.service';

@Component({
  selector: 'app-hero-winner-spot',
  templateUrl: './hero-winner-spot.component.html',
  styleUrls: ['./hero-winner-spot.component.scss']
})
export class HeroWinnerSpotComponent implements OnInit, OnDestroy {

  public showCounter = false;
  public countdownDate: Date;
  public isSafariBrowser = false;

  private lotterySubscription: Subscription;
  private router: Router;
  private readonly lotteryService: LotteryService;
  private salestopSubscription = new Subscription();
  private readonly clientService: ClientService;

  public constructor(router: Router, lotteryService: LotteryService, clientService: ClientService) { 
    this.router = router;
    this.lotteryService = lotteryService;
    this.clientService = clientService;
  }

  public ngOnInit(): void
  {
    this.isInUrgencyPeriod();
    this.getBrowserVersion();
  }

  public isInUrgencyPeriod(): void
  {
      this.lotterySubscription = this.lotteryService.isInUrgencyPeriod().subscribe((isUrgency) => {
          this.showCounter = isUrgency;
          if(isUrgency === true){
            this.setCountdownDate();
          }
      });
  }

  public showPage(): void
  {
    this.router.navigate(['/lodder-til-salg']);
  }

  private setCountdownDate(): void
  {
    this.salestopSubscription = this.lotteryService.getSaleStop().subscribe((result) => {
      const seconds = parseInt(result.Seconds, 10) || 0;
      const minutes = parseInt(result.Minutes, 10) || 0;
      const hours = parseInt(result.Hours, 10) || 0;
      const days = parseInt(result.Days, 10) || 0;

      const x = new Date();
      x.setDate(x.getDate() + days);
      x.setHours(x.getHours() + hours);
      x.setMinutes(x.getMinutes() + minutes);
      x.setSeconds(x.getSeconds() + seconds);

      this.countdownDate = x; 
    });
  }

  private getBrowserVersion(): void
    {
        if(this.clientService.getClientInfo().Browser.indexOf("safari") !== -1 || this.clientService.getClientInfo().Browser.indexOf("Safari") !== -1)
        {
            this.isSafariBrowser = true;
        }
        else
        {
            this.isSafariBrowser = false;
        }
    }

  public ngOnDestroy(): void
  {
    if(this.salestopSubscription){
      this.salestopSubscription.unsubscribe();
    }
    this.lotterySubscription.unsubscribe
  }
}
